import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';

import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, Router } from '@angular/router';

import { PortalTheme } from '../themes/theme.primeng';
import { preInitRoutes } from './app.routes';
import { AppInitializationService } from './core/services/app-initialization.service';
import { RouteConfigService } from './core/services/route-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    providePrimeNG({
      ripple: true,
      theme: {

        preset: PortalTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.portal-dark-theme',
          cssLayer: {
            name: 'primeng',
            // Must match the layer order in tailwind-context.css.
            // See docs/architecture/css-layers.md for the full model.
            order: 'base, resets, primeng, overrides, tailwind-utilities'
          }
        }
      },
    }),
    provideAppInitializer(() => {
      const initService = inject(AppInitializationService);
      const routeConfigService = inject(RouteConfigService);
      const router = inject(Router);
      return initService.initialize().then(() => {
        router.resetConfig(routeConfigService.getRoutes());
      });
    }),
    provideRouter(preInitRoutes),
    provideAnimationsAsync(),

    MessageService,
    ConfirmationService,
    DialogService,
    { provide: APP_BASE_HREF, useValue: '/v2' },
  ]
};

